import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import { Notification } from '../components/Notification';
import { NewItemCard } from '../components/NewItemCard';

const db = firebase.firestore();

export function ListNew() {
  const { user } = useAuthState(firebase.auth());
  const baseList = {
    time: new Date(),
    createdById: user.uid,
    householdUid: '',
    shopper: [false, false, false],
    listDone: false,
    store: {},
    items: []
  };
  const [list, setList] = useState(baseList);
  const [address, setAddress] = useState('');
  const [addressList, setAddressList] = useState();
  const [date, setDate] = useState(new Date());
  const [errors, setErrors] = useState('');

  const handleAddressChange = e => {
    setAddress(e.target.value);
  };

  const saveListToDb = async e => {
    e.preventDefault();

    if (!address) {
      setErrors('Must have a store');

      setTimeout(() => {
        setErrors('');
      }, 5000);

      return;
    } else if (list.items > 1) {
      setErrors('Must have some items');

      setTimeout(() => {
        setErrors('');
      }, 5000);

      return;
    } else {
      setErrors('');
    }

    try {
      const userDoc = await db
        .collection('users')
        .doc(user.uid)
        .get();
      const { householdUid } = await userDoc.data();
      const currentList = { ...list };
      const finalList = {
        ...currentList,
        householdUid
      };
      const saveList = await db.collection('lists').add({
        ...finalList
      });
      if (saveList) {
        setList(baseList);
        setAddress('');
      }

      // TODO: Save location to location collection on save
      // TODO: Once saved, add location UID to list object
      // TODO: Create index of frequented stores for users
      //     New collection that ties user to stores
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddressSearch = async e => {
    // TODO: Check our DB for location before serving results
    e.preventDefault();

    if (!address) {
      setErrors('Must have some text');

      setTimeout(() => {
        setErrors('');
      }, 5000);

      return;
    } else {
      setErrors('');
    }

    const baseUrl =
      'https://api.locationiq.com/v1/autocomplete.php?key=c902510a6751ab&q=';
    const url = `${baseUrl}${address}`;
    const results = await fetch(url);
    const resultsJson = await results.json();
    setAddressList(resultsJson);
  };

  const handleAddressSelect = (e, addressSelect) => {
    e.preventDefault();
    const { display_name } = addressSelect;
    setAddress(display_name);
    setAddressList('');
    const newList = { ...list };
    const finalList = {
      ...newList,
      store: addressSelect
    };
    setList(finalList);
  };

  const calendarChange = newDate => {
    setDate(newDate);
    const newList = { ...list };
    const finalList = {
      ...newList,
      time: newDate
    };
    setList(finalList);
  };

  const saveItem = formValue => {
    const newList = { ...list };
    const items = newList.items;
    const newItems = [
      ...items,
      {
        text: formValue,
        done: false,
        aisle: 2
      }
    ];
    const finalList = {
      ...newList,
      items: [...newItems]
    };
    setList(finalList);
  };

  const deleteItem = (e, index) => {
    e.preventDefault();
    const newList = { ...list };
    const items = newList.items;
    const newItems = items
      .slice(0, index)
      .concat(items.slice(index + 1, items.length));
    const finalList = {
      ...list,
      items: [...newItems]
    };
    setList(finalList);
  };

  const markItem = (e, index, listId = 0, listIndex = 0) => {
    e.preventDefault();
    const newList = { ...list };
    const items = newList.items;
    const item = items[index];
    item.done = !item.done;
    const finalList = {
      ...list,
      items: [...items]
    };
    setList(finalList);
  };

  return (
    <>
      {errors && <Notification>{errors}</Notification>}
      <Header>New List</Header>
      <NewItemCard
        items={list.items}
        list={list}
        saveListToDb={saveListToDb}
        markItem={markItem}
        deleteItem={deleteItem}
        saveItem={saveItem}
        setList={setList}
        baseList={baseList}
        handleAddressChange={handleAddressChange}
        handleAddressSearch={handleAddressSearch}
        address={address}
        addressList={addressList}
        handleAddressSelect={handleAddressSelect}
        calendarChange={calendarChange}
        calendarValue={date}
      />
    </>
  );
}

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 30px;
`;
